import React, { useEffect, useMemo, useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useAuthStore from "../../stores/authStore";
import useUserProfileStore from "../../stores/userProfileStore";
import { trackEvent } from "../../utils/ga";
import { getDefaultPathForRole, getNavItemsForRole } from "../../utils/accessControl";
import "./SiteHeader.css";

const SiteHeader = () => {
    const user = useAuthStore((state) => state.user);
    const logout = useAuthStore((state) => state.logout);
    const role = useUserProfileStore((state) => state.role);
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [theme, setTheme] = useState(
        () => (typeof window !== "undefined" && window.localStorage.getItem("ls-admin-theme")) || "dark"
    );

    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        window.localStorage.setItem("ls-admin-theme", theme);
    }, [theme]);

    const navItems = useMemo(() => getNavItemsForRole(role), [role]);
    const homePath = user ? (role ? getDefaultPathForRole(role) : "/") : "/login";

    const isActivePath = (path) => {
        if (path === "/") {
            return location.pathname === "/";
        }

        if (path === "/posttests") {
            return (
                location.pathname === "/posttests" ||
                location.pathname.startsWith("/posttests/") ||
                location.pathname.startsWith("/test/") ||
                location.pathname.startsWith("/newposttest")
            );
        }

        return location.pathname === path || location.pathname.startsWith(`${path}/`);
    };

    const onNavigate = (item) => {
        trackEvent("navigation", item.event);
    };

    return (
        <header className="siteheader">
            <div className="siteheader__bar">
                <Link
                    className="siteheader__brand"
                    to={homePath}
                >
                    <span>Latest Sightings</span>
                    <small>Admin Panel</small>
                </Link>

                <button
                    className="siteheader__menu-toggle"
                    aria-label={menuOpen ? "Close menu" : "Open menu"}
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen((prev) => !prev)}
                >
                    {menuOpen ? <FiX /> : <FiMenu />}
                </button>

                <nav className={`siteheader__nav ${menuOpen ? "open" : ""}`}>
                    {user && navItems.map((item) => (
                        <Link
                            key={item.path}
                            className={`siteheader__link ${isActivePath(item.path) ? "active" : ""}`}
                            onClick={() => onNavigate(item)}
                            to={item.path}
                        >
                            {item.label}
                        </Link>
                    ))}

                    <div className="siteheader__auth">
                        <button
                            className="siteheader__theme-toggle"
                            onClick={() => setTheme((prev) => (prev === "dark" ? "light" : "dark"))}
                        >
                            {theme === "dark" ? "Light Mode" : "Dark Mode"}
                        </button>

                        {user ? (
                            <button
                                className="siteheader__auth-button primary"
                                onClick={(e) => {
                                    trackEvent("auth", "logout");
                                    logout(e);
                                    navigate("/login");
                                }}
                            >
                                Logout
                            </button>
                        ) : (
                            <>
                                <Link
                                    className="siteheader__auth-button"
                                    to="/login"
                                >
                                    Login
                                </Link>
                                <Link
                                    className="siteheader__auth-button primary"
                                    to="/register"
                                >
                                    Signup
                                </Link>
                            </>
                        )}
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default SiteHeader;
